<template>
  <div>
    <el-table
      :data="vouchersList"
      width="100"
      class="mb-20 vouchers-table"
      v-loading="isLoading"
    >
      <el-table-column
        prop="Name"
        label="Code Name"
        width="200px"
      />

      <el-table-column
        prop="CouponCode"
        label="Voucher Code"
        width="200px"
      />

      <el-table-column
        prop="IsVoucherActivated"
        label="Status"
        :formatter="(row, column, cellValue) => cellValue ? 'Active' : 'Expired'"
        width="80px"
      />

      <el-table-column
        prop="DiscountValue"
        label="Value"
        width="100px"
      />

      <el-table-column
        prop="DiscountType"
        label="Voucher type(£/%)"
        width="130px"
        :formatter="getVoucherTypeFormatter"
      />

      <el-table-column
        prop="MinimumOrderValue"
        label="Minimum Order Value"
        width="160px"
        :formatter="(row, column, cellValue) => cellValue || '£--.--'"
      />

      <el-table-column
        prop="MaximumDiscountAmount"
        label="Maximum Discount Amount"
        width="190px"
        :formatter="(row, column, cellValue) => cellValue || '£--.--'"
      />

      <el-table-column
        prop="MinimumQuantity"
        label="Minimum Quantity"
        width="140px"
        :formatter="(row, column, cellValue) => cellValue || 'N/A'"
      />

      <el-table-column
        prop="MaximumUsageCountPerCustomer"
        label="Max Usage Per Customer"
        width="180px"
        :formatter="(row, column, cellValue) => cellValue || 'N/A'"
      />

      <el-table-column
        prop="ApplicableOrderSource"
        label="Applicable Order"
        width="120px"
        :formatter="getOrderSourceFormatter"
      />

      <el-table-column
        prop="duration"
        label="Duration"
        width="150px"
      />

      <el-table-column
        prop="Customers"
        label="Customers"
        width="170px"
      >
        <template slot-scope="scope">
          <div class="layout__display-flex justify-center">
            <el-button
              class="button-red button__base"
              :disabled="isLoading"
              @click.prevent="handleList(scope, 'customers')"
            >
              View customers ({{ scope.row.Customers.length }})
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="Products"
        label="Products"
        width="170px"
      >
        <template slot-scope="scope">
          <div class="layout__display-flex justify-center">
            <el-button
              class="button-red button__base"
              :disabled="isLoading || scope.row.ApplicableOrderSource === 1"
              @click.prevent="handleList(scope, 'products')"
            >
              View products ({{ scope.row.Products.length }})
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        width="135px"
      >
        <template slot-scope="scope">
          <div class="layout__display-flex">
            <el-button
              class="button-red button__base mr-10"
              :disabled="isLoading"
              @click.prevent="editItem(scope.$index)"
            >
              Edit
            </el-button>

            <el-button
              class="button__background-red-border button__base"
              :disabled="isLoading"
              @click.prevent="onDelete(scope.$index)"
            >
              Delete
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'VouchersTable',

  props: {
    vouchersList: {
      type: Array,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    onDelete(index) {
      this.$emit('delete-item', this.vouchersList[index])
    },

    editItem(index) {
      this.$emit('edit-item', index)
    },

    getVoucherTypeFormatter(row, column, cellValue) {
      const types = {
        0: 'Percentage',
        1: 'Amount',
      };

      return types[cellValue] || 'N/A';
    },

    getOrderSourceFormatter(row, column, cellValue) {
      const types = {
        1: 'Photofixr',
        6: 'PdfUpload',
        7: 'IMA',
      };

      return types[cellValue] || 'N/A';
    },

    handleList(scope, field) {
      this.$emit('handle-connections', { scope, field })
    },
  },
};
</script>

<style>
.vouchers-table .el-table__body-wrapper {
  max-height: 600px;
  overflow: auto;
}
</style>
